
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobility-bonus/intro",
      function () {
        return require("private-next-pages/mobility-bonus/intro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobility-bonus/intro"])
      });
    }
  